import { render, staticRenderFns } from "./SearchCategory.vue?vue&type=template&id=407c4efd&"
import script from "./SearchCategory.vue?vue&type=script&lang=js&"
export * from "./SearchCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports